/* 47X · FAM47 · Panel admin (solo Baruc). Lista miembros/cuentas + alta manual + baja.
   Usa tu sesión IG (window.FAM47_TOKEN, compartida con /pages/atletas). Auth admin la valida el Worker.
   Añádelo a /pages/admin-fam47 con un <div id="fam47-admin-root"></div>. */
(function () {
  'use strict';
  function token() { try { return localStorage.getItem('fam47:token') || ''; } catch (e) { return ''; } }
  function api(ep, payload) {
    var sep = ep.indexOf('?') === -1 ? '?' : '&';
    return fetch('/apps/atletas/' + ep + sep + 'atleta_token=' + encodeURIComponent(token()), {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload || {})
    }).then(function (r) { return r.json().catch(function () { return { ok: false, error: 'server_error' }; }); });
  }
  var CSS = '\
  #fam47-admin-root{font-family:Jost,system-ui,sans-serif;color:#e8eaed;max-width:960px;margin:0 auto;padding:18px;}\
  .fa47{background:#0b0d10;border:1px solid rgba(0,255,102,.15);border-radius:14px;padding:18px;margin-bottom:16px;}\
  .fa47 h2{font-family:"Archivo Black",sans-serif;font-size:15px;letter-spacing:.04em;color:#39FF14;margin:0 0 12px;text-transform:uppercase;}\
  .fa47 table{width:100%;border-collapse:collapse;font-size:12.5px;}\
  .fa47 th,.fa47 td{text-align:left;padding:7px 8px;border-bottom:1px solid rgba(255,255,255,.07);}\
  .fa47 th{color:#8a8f98;font-weight:600;text-transform:uppercase;font-size:10.5px;letter-spacing:.06em;}\
  .fa47 input{background:#111318;border:1px solid rgba(255,255,255,.14);border-radius:8px;color:#eef0f2;padding:9px 11px;font-size:13px;margin:0 6px 6px 0;font-family:inherit;}\
  .fa47 button{border:none;border-radius:8px;padding:8px 13px;font-family:"Archivo Black",sans-serif;font-size:11px;letter-spacing:.04em;text-transform:uppercase;cursor:pointer;}\
  .fa47 .pri{background:#39FF14;color:#04120a;}\
  .fa47 .del{background:transparent;color:#ff6b6b;border:1px solid rgba(255,107,107,.4);}\
  .fa47 .tag{font-size:10px;padding:2px 7px;border-radius:99px;background:rgba(0,255,102,.12);color:#39FF14;}\
  .fa47 .tag--m{background:rgba(252,211,77,.14);color:#fcd34d;}\
  .fa47__msg{font-size:12.5px;color:#8a8f98;margin-top:8px;min-height:15px;}';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }

  var cssPuesto = false;
  function ponCSS() {
    if (cssPuesto) return;
    cssPuesto = true;
    var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);
  }
  function boot(root) {
    ponCSS();
    root.innerHTML = '<div class="fa47"><h2>Código de acceso de HOY</h2>'
      + '<div style="font-family:Archivo Black,monospace;font-size:36px;letter-spacing:.18em;color:#39FF14;margin:4px 0" data-code>······</div>'
      + '<div class="fa47__msg" data-code-date></div>'
      + '<label style="display:flex;gap:9px;align-items:flex-start;margin-top:10px;font-size:12.5px;color:#c9cdd2;cursor:pointer"><input type="checkbox" data-reauth style="margin-top:2px"> <span>Pedir el código a TODOS en su próximo login (los saca y deben volver a poner el código de hoy)</span></label></div>'
      + '<div class="fa47" data-alta><h2>Alta manual (pago por fuera)</h2>'
      + '<input data-e placeholder="correo"><input data-n placeholder="nombre"><input data-c placeholder="customer_id (opcional)">'
      + '<button class="pri" data-add>Dar de alta</button><div class="fa47__msg" data-m></div></div>'
      + '<div class="fa47"><h2>Miembros FAM47 (<span data-mc>…</span>)</h2><div data-members>Cargando…</div></div>'
      + '<div class="fa47"><h2>Cuentas creadas (<span data-ac>…</span>)</h2><div data-accounts>Cargando…</div></div>';
    var msg = root.querySelector('[data-m]');
    var codeEl = root.querySelector('[data-code]'), reauthCb = root.querySelector('[data-reauth]');
    function loadCode() {
      api('admin/daily-code').then(function (r) {
        if (!r || !r.ok) {
          /* Antes esto hacía `return` a secas: el código se quedaba en «······»
             para siempre sin decir por qué. Ahora se explica. */
          codeEl.textContent = '—';
          root.querySelector('[data-code-date]').textContent =
            (r && r.error === 'not_admin')
              ? 'Tu cuenta no tiene permisos de admin'
              : 'No se pudo leer el código · ' + ((r && r.error) || 'sin respuesta');
          return;
        }
        codeEl.textContent = r.code;
        root.querySelector('[data-code-date]').textContent = 'Cambia solo cada día · manda esto al grupo (fecha ' + (r.date || '') + ')';
        if (reauthCb) reauthCb.checked = !!r.loginCodeRequired;
      });
    }
    if (reauthCb) reauthCb.addEventListener('change', function () {
      api('admin/reauth', { on: reauthCb.checked }).then(function () { loadCode(); });
    });
    function load() {
      api('admin/members').then(function (r) {
        if (!r.ok) {
          var txt = r.error === 'not_admin'
            ? 'Tu cuenta no tiene permisos de admin'
            : (r.error === 'not_logged_in' ? 'Sesión caducada · vuelve a entrar' : 'Error: ' + r.error);
          root.querySelector('[data-members]').textContent = txt;
          root.querySelector('[data-accounts]').textContent = txt;
          root.querySelector('[data-mc]').textContent = '0';
          root.querySelector('[data-ac]').textContent = '0';
          if (r.error === 'not_logged_in') { try { localStorage.removeItem('fam47:token'); } catch (e) {} pideLogin(root); }
          return;
        }
        var m = r.members || [], a = r.accounts || [];
        root.querySelector('[data-mc]').textContent = m.length;
        root.querySelector('[data-ac]').textContent = a.length;
        var mh = '<table><tr><th>Correo</th><th>Nombre</th><th>Origen</th><th>Cuenta</th><th></th></tr>';
        m.forEach(function (x) {
          mh += '<tr><td>' + esc(x.email) + '</td><td>' + esc(x.name) + '</td>'
            + '<td><span class="tag ' + (x.source === 'manual' ? 'tag--m' : '') + '">' + (x.source === 'manual' ? 'manual' : '$580') + '</span></td>'
            + '<td>' + (x.claimed ? '✓' : '—') + '</td>'
            + '<td><button class="del" data-revoke="' + esc(x.email) + '">Baja</button></td></tr>';
        });
        root.querySelector('[data-members]').innerHTML = mh + '</table>';
        var ah = '<table><tr><th>Usuario</th><th>Correo</th><th>IP registro</th><th>Creada</th><th>Últ. login</th></tr>';
        a.forEach(function (x) { ah += '<tr><td>@' + esc(x.username) + '</td><td>' + esc(x.email) + '</td><td>' + esc(x.reg_ip || '—') + '</td><td>' + esc((x.created_at || '').slice(0, 10)) + '</td><td>' + esc((x.last_login || '').slice(0, 10)) + '</td></tr>'; });
        root.querySelector('[data-accounts]').innerHTML = ah + '</table>';
      });
    }
    root.querySelector('[data-add]').addEventListener('click', function () {
      var email = root.querySelector('[data-e]').value.trim();
      var name = root.querySelector('[data-n]').value.trim();
      var customerId = root.querySelector('[data-c]').value.trim();
      msg.textContent = 'Guardando…';
      api('admin/approve', { email: email, name: name, customerId: customerId }).then(function (r) {
        msg.textContent = r.ok ? ('Alta: ' + r.email) : ('Error: ' + r.error);
        if (r.ok) { root.querySelector('[data-e]').value = ''; root.querySelector('[data-n]').value = ''; root.querySelector('[data-c]').value = ''; load(); }
      });
    });
    root.querySelector('[data-members]').addEventListener('click', function (e) {
      var em = e.target.getAttribute('data-revoke'); if (!em) return;
      if (!confirm('¿Dar de baja a ' + em + '? Pierde acceso y se borra su cuenta.')) return;
      api('admin/revoke', { email: em }).then(function (r) { msg.textContent = r.ok ? ('Baja: ' + em) : ('Error: ' + r.error); load(); });
    });
    load();
    loadCode();
  }
  /* ── Login dentro del propio panel ──
     Antes esta página daba por hecho que ya venías con sesión de
     /pages/atletas. Si no, se quedaba en blanco sin explicar nada.
     Ahora, si no hay sesión válida, pide usuario y contraseña aquí
     mismo contra el mismo endpoint del Worker (auth/login) y entra
     directo al panel. */
  function pideLogin(root, aviso) {
    root.innerHTML = '<div class="fa47"><h2>Entrar al panel</h2>'
      + '<div class="fa47__msg" data-lm>' + (aviso || 'Inicia sesión con tu cuenta FAM47 para ver el panel') + '</div>'
      + '<input data-lu placeholder="usuario" autocomplete="username" autocapitalize="off" spellcheck="false">'
      + '<input data-lp placeholder="contraseña" type="password" autocomplete="current-password">'
      + '<input data-lc placeholder="código del día (solo si te lo pide)" autocapitalize="characters">'
      + '<button class="pri" data-lb>ENTRAR</button></div>';
    var u = root.querySelector('[data-lu]'), p = root.querySelector('[data-lp]'),
        c = root.querySelector('[data-lc]'), b = root.querySelector('[data-lb]'),
        m = root.querySelector('[data-lm]');
    function entra() {
      var user = (u.value || '').trim(), pass = p.value || '', code = (c.value || '').trim();
      if (!user || !pass) { m.textContent = 'Pon tu usuario y tu contraseña'; return; }
      b.disabled = true; b.textContent = 'ENTRANDO…'; m.textContent = '';
      var cuerpo = { username: user, password: pass };
      if (code) cuerpo.code = code;
      fetch('/apps/atletas/auth/login', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(cuerpo)
      }).then(function (r) { return r.json().catch(function () { return { ok: false, error: 'server_error' }; }); })
        .then(function (r) {
          b.disabled = false; b.textContent = 'ENTRAR';
          if (r && r.ok && r.token) {
            try { localStorage.setItem('fam47:token', r.token); } catch (e) {}
            boot(root);
            return;
          }
          var err = (r && r.error) || 'server_error';
          m.textContent = (err === 'credenciales_invalidas' || err === 'usuario_o_password') ? 'Usuario o contraseña incorrectos'
            : err === 'no_es_miembro' ? 'Esa cuenta no es miembro FAM47'
            : err === 'usuario_invalido' ? 'Usuario inválido'
            : err === 'codigo_requerido' ? 'Hace falta el código del día'
            : err === 'codigo_invalido' ? 'Ese código del día no es correcto'
            : 'No se pudo entrar · ' + err;
        })
        .catch(function () { b.disabled = false; b.textContent = 'ENTRAR'; m.textContent = 'Sin conexión con el servidor'; });
    }
    b.addEventListener('click', entra);
    [u, p, c].forEach(function (el) {
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter') entra(); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.getElementById('fam47-admin-root');
    if (!root) return;
    ponCSS();
    var t = token();
    if (!t) { pideLogin(root); return; }
    /* Se valida la sesión antes de pintar el panel: si el token murió,
       se limpia y se pide login en vez de dejar la pantalla muda. */
    fetch('/apps/atletas/auth/me?atleta_token=' + encodeURIComponent(t))
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (d) {
        if (d && d.ok) { boot(root); return; }
        try { localStorage.removeItem('fam47:token'); } catch (e) {}
        pideLogin(root, 'Tu sesión caducó · vuelve a entrar');
      })
      .catch(function () { pideLogin(root, 'Sin conexión con el servidor · intenta de nuevo'); });
  });
})();
